<div [class.bright]="isBright">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <div class="row legend-sec">
                <div class="col-lg-6 ">
                    <span class="form-field-legend">
                        <font color="red">* Fields are Mandatory</font>
                    </span>
                    <!-- <span class="form-field-legend">
                        <font color="blue"># Fields are Numeric</font>
                    </span> -->
                    <span class="form-field-legend">
                        <font color="green">## Fields are Decimal</font>
                    </span>
                </div>
                <div class="col-lg-2 text-center doctype-wrap">
                    <span>
                        <small>Work Item Type</small>
                        <i class="material-icons" title="Edit"
                            (click)="isOpenDoctypeModel = true;showModal(documentTypeModal,'sm')">edit</i>
                    </span>
                    <br />
                    <span class=" doctype-name">{{ selectedDocumentType.docTypeName }}</span>
                </div>

            </div>

            <div class="row form-control-sec DAO_datacss">



                <mat-tab-group #tabGroup mat-stretch-tabs="true" mat-align-tabs="start">
                    <mat-tab label="DOA Matrix">
                        <div class="row selection-sec">
                            <div class="grid_panel">
                                <div class="form-container">
                                    <!-- <app-dynamic-form [model]="model"></app-dynamic-form> -->
                                    <form [formGroup]=frmInvoice>
                                        <div class="row ">



                                            <div class="col-lg-3">
                                                <div class="form-group">
                                                    <mat-form-field [style.width.%]="100">
                                                        <mat-label for="dao_selection">Select DOA Type</mat-label>
                                                        <mat-select [(ngModel)]="selected_doa_Type"
                                                            [value]="selected_doa_Type" formControlName="Doatype"
                                                            (selectionChange)="onSelect_doa_Type($event.value)"
                                                            id="dao_selection">
                                                            <mat-option [value]="doc" *ngFor="let doc of doa_Typelist">
                                                                {{doc.Name}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="doa_matrix">Select DOA Matrix</mat-label>
                                                    <mat-select [(ngModel)]="selected_doa_Matrix"
                                                        [value]="selected_doa_Matrix" formControlName="doa_Matrix"
                                                        id="doa_matrix">
                                                        <mat-option [value]="">
                                                            --select--
                                                        </mat-option>
                                                        <mat-option [value]="doc" *ngFor="let doc of doa_matrixlist">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="queue_selection">Select Queue</mat-label>
                                                    <mat-select [(ngModel)]="selected_queue" [value]="selected_queue"
                                                        formControlName="queue" id="queue_selection">
                                                        <mat-option [value]="doc" *ngFor="let doc of processTypeList">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="approved_queue">Select Approved Queue</mat-label>
                                                    <mat-select formControlName="approved_queue"
                                                        [(ngModel)]="selected_approved_queue"
                                                        [value]="selected_approved_queue" id="approved_queue">
                                                        <mat-option [value]="">
                                                            --select--
                                                        </mat-option>
                                                        <mat-option [value]="doc"
                                                            *ngFor="let doc of processTypeList_appr">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="rejection_queue">Select Rejected Queue</mat-label>
                                                    <mat-select formControlName="rejected_queue"
                                                        [(ngModel)]="selected_rejected_queue"
                                                        [value]="selected_rejected_queue" id="rejection_queue">
                                                        <mat-option [value]="">
                                                            --select--
                                                        </mat-option>
                                                        <mat-option [value]="doc"
                                                            *ngFor="let doc of processTypeList_rej">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="forwarded_queue">Select Forwarded Queue</mat-label>
                                                    <mat-select formControlName="Forward_queue"
                                                        [(ngModel)]="selected_Forward_queue"
                                                        [value]="selected_Forward_queue" id="forwarded_queue">
                                                        <mat-option [value]="0">
                                                            --select--
                                                        </mat-option>
                                                        <mat-option [value]="doc"
                                                            *ngFor="let doc of processTypeList_forwd">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="rule_level">Select Rule Level</mat-label>
                                                    <mat-select formControlName="Rule_level"
                                                        [(ngModel)]="Selected_Rule_level" [value]="Selected_Rule_level"
                                                        id="rule_level">
                                                        <mat-option [value]="">
                                                            --select--
                                                        </mat-option>
                                                        <mat-option [value]="doc" *ngFor="let doc of doa_Rulelevellist">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-3">
                                                <mat-form-field [style.width.%]="100">
                                                    <mat-label for="role_selection">Select Role</mat-label>
                                                    <mat-select formControlName="Role" multiple
                                                        [(ngModel)]="Selected_Role" id="role_selection">

                                                        <mat-option [value]="">
                                                            --select--
                                                        </mat-option>
                                                        <mat-option [value]="doc.Id" *ngFor="let doc of RoleList">
                                                            {{doc.Name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-3">
                                                    <mat-checkbox formControlName="Is_Active" [(ngModel)]="Is_Active">
                                                        Active
                                                    </mat-checkbox>
                                                </div>
                                                <div class="col-lg-3">
                                                    <mat-checkbox formControlName="Amt_lmt" [(ngModel)]="Amt_lmt">
                                                        Amount Limit Check
                                                    </mat-checkbox>
                                                </div>

                                                <div class="col-lg-3">
                                                    <mat-checkbox formControlName="Ass_lvl" [(ngModel)]="Ass_lvl">
                                                        Skip Assign Level
                                                    </mat-checkbox>
                                                </div>
                                                <div class="col-lg-3">
                                                    <mat-checkbox formControlName="last_lvl" [(ngModel)]="last_lvl">
                                                        Last level Mandatory
                                                    </mat-checkbox>
                                                </div>
                                            </div>
                                             <input type="hidden" formControlName="csrfToken" />
                                            <div class="row mt_20">
                                                <div class="col-lg-5 text-right"></div>
                                                <div class="col-lg-2 text-right">
                                                    <button class="btncss " [class.btn_disable]="frmInvoice?.invalid"
                                                        [class.btn_primary]="!frmInvoice?.invalid"
                                                        [disabled]="frmInvoice?.invalid"
                                                        (click)="submitInvoice()">Submit</button>
                                                </div>
                                                <div class="col-lg-5 text-right"></div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="DOA Rule">
                        <div class="row selection-sec">
                            <div class="grid_panel">
                                <div class="form-container">
                                    <form [formGroup]=frmRulesave>
                                        <div class="row  DAO_datacss">
                                            <div class="row form-control-sec">
                                                <div class="">
                                                    <div class="row cmnt_sec_h_100">
                                                        <div class="col-lg-1"></div>
                                                        <div class="col-lg-3">
                                                            <mat-form-field [style.width.%]="100">
                                                                <mat-label for="field_selection">Select
                                                                    Fields</mat-label>
                                                                <mat-select formControlName="fieldselected" multiple
                                                                    id="field_selection">

                                                                    <mat-option [value]="">
                                                                        --select--
                                                                    </mat-option>
                                                                    <mat-option [value]="doc"
                                                                        *ngFor="let doc of fieldList">
                                                                        {{doc.Name}}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="col-lg-8 cmnt_sec_h_100">
                                                            <mat-form-field formControlName="txtdata"
                                                                style="width: 700px !important">
                                                                <textarea matInput required cols="350" rows="2"
                                                                    name="Rule" placeholder="Rule"
                                                                    [(ngModel)]="Rule_desc" required></textarea>
                                                            </mat-form-field>
                                                        </div>

                                                    </div>
                                                            <input type="hidden" formControlName="csrfToken" />
                                                    <div class="row mt_20">
                                                        <div class="col-lg-5 text-right"></div>
                                                        <div class="col-lg-2 text-right">
                                                            <button class="btncss  "
                                                                [class.btn_disable]="frmRulesave?.invalid"
                                                                [class.btn_primary]="!frmRulesave?.invalid"
                                                                [disabled]="frmRulesave?.invalid"
                                                                (click)="submitInvoice()">Submit</button>
                                                        </div>
                                                        <div class="col-lg-5 text-right"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </mat-tab>

                </mat-tab-group>
            </div>


            <div class="row form-control-sec DAO_datacss">


                <div class="row selection-sec">
                    <div class="grid_panel">
                        <app-basic-gridview [lstData]="lstData" [columnsToHide]="columnsToHide" gridTitle="DOA Matrix"
                            [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                            [showPagination]="true" (cellClickEvent)="onGridCellClick($event)"
                            [columnsToExcludeFromExport]="[]" [hyperlinkCols]="hyperlinkCols">
                        </app-basic-gridview>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>



<ng-template #documentTypeModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Select Work Item Type</h5>
            <button type="button" class="close model_close_btn"
                (click)="isOpenDoctypeModel = false;modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <ul class="selection-list">
                    <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                        *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                        <div class="selected-check">{{ docType.docTypeName }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>